/* @flow */

export default {
  root: {
    width: 16,
    height: 16,
  },
  'root-large': {
    width: 24,
    height: 24,
  },
};
